<template lang="pug">
div
  v-card.wallpaper(flat)
    v-container.limitw
      v-row
        v-col(v-if="!$store.state.windowSize.isMobile" cols="12" sm="10" offset-sm="1" offset-md="0" md="7" lg="8")
          v-card.rounded-lg(color="transparent")
            v-responsive( :aspect-ratio="16/7")
              v-carousel(hide-delimiters height="100%" cycle interval="10000" prev-icon="fas fa-angle-left" next-icon="fas fa-angle-right")
                v-carousel-item(v-for="(item, index) in banners" :key="index")
                  a(:href="item.link" target="_blank")
                    v-img(:src="item.imagen")
        v-col(cols="12" sm="8" offset-sm="2" offset-md="0" md="5" lg="4")
          v-card(dark).rounded-lg.login-panel.elevation-5
            v-card-text.pa-0(style="height: auto;")
              c-login-form
            v-divider
            v-card-actions
              v-menu(offset-y)
                template(v-slot:activator="{ on, attrs }")
                  v-btn.txtn(large color="blue darken-1" v-bind="attrs" v-on="on" style="height:50px;").pl-4.pr-3
                    | Convocatorias  <br>Vigentes  
                    v-icon(size=30) fas fa-file-pdf
                v-list(dense)
                  v-list-item(v-for="(item, index) in items" :key="index" :href="item.ref" target="_blank")
                    v-list-item-title.text-center {{ item.title }}
              v-spacer
              v-btn.txtn(large, color="blue darken-1" @click="abrirPrecarga" style="height:65px;").pl-5.pr-5
                |Convocatorias<br>Administrativas<br>(Personal sin RDA)
          v-card(flat, color="transparent").mt-3
            v-card-actions.pa-0.pt-0
              v-spacer
              c-recaptcha-logo
              v-spacer
        v-col(v-if="$store.state.windowSize.isMobile" cols="12" sm="10" offset-sm="1" offset-md="0" md="7" lg="8").pa-0
          v-card(color="transparent" flat).rounded-0.mt-5
            v-responsive( :aspect-ratio="16/7")
              v-carousel(hide-delimiters height="100%" cycle prev-icon="fas fa-angle-left" next-icon="fas fa-angle-right")
                v-carousel-item(v-for="(item, index) in banners" :key="index")
                  a(:href="item.link" target="_blank")
                    v-img(:src="item.imagen")
  v-container.mt-8.limitw
    v-row
      //-v-col.text-center.pa-0(cols="12")
        v-img(src="/img/fecha-limite-inscripcion.jpg" width="500px" style="margin:-10px auto 10px auto")
      v-col.text-center.pa-0(cols="12" style="border-bottom:#F39400 solid 2px;").mb-3
        div(style="display:inline;float:left;width:100%").ma-0.pa-0
          v-tabs(background-color="transparent" color="#0652a1" v-model="currentTab" slider-size="3" slider-color="#F39400")
            v-tab Publicaciones
            v-tab Videos
            v-tab(@click="scrollToBTabs()") Bibliografías
            v-tab(@click="scrollToBTabs()") Directrices
        //-h2.title.light-blue--text.text-left.text--darken-4(style="width:200px;display:inline;float:left;").pl-4.pt-4 Publicaciones
        //-h2.title.light-blue--text.text-left.text--darken-4(style="width:200px;display:inline;float:left;").pl-4.pt-4 Videos
      v-col.pa-0
        v-text-field(v-show="currentTab == 0" label="Buscar publicación" autocomplete="off" dense append-icon="fas fa-search" color="orange" placeholder="Buscar publicación..." solo v-model="searchTerm" @change="onChangeTerm" @keyup="onChangeTerm" style="display:inline;float:right;max-width:300px;margin-bottom:10px;" hide-details)
      //-v-col(cols=12).red.pa-0
      v-tabs-items(v-model="currentTab" style="width:100%").ma-0.pa-0.transpare2t
        v-tab-item.ma-0.pa-0(style="width:100%")
          v-col.text-center.pa-0(cols="12" v-if="filterByTerm.length == 0")
            v-alert(type="warning" color="orange" max-width="400px").center.mt-15.mb-15 No se encontraron registros para: "{{ searchTerm }}"
          v-col.text-center.pa-0(cols="12" v-if="searchTerm.length<1")
            div(v-masonry="masonryId" transition-duration="0.4s" item-selector=".item")
              div(v-masonry-tile="masonryId" :style="masonryStyle" cols="12" md="6" v-for="(publicacion, index) in publicaciones.slice(((page-1)*limitPerPage),(page*limitPerPage))" :key="index").item.ma-0.pa-0
                c-noticia-v4(
                  :imagen="publicacion.imagen",
                  :titulo="publicacion.titulo",
                  :fecha="publicacion.fecha",
                  :description="publicacion.description",
                  :tipo="publicacion.tipo",
                  :archivo="publicacion.archivo"
                ).ma-2
          v-col.text-center.pa-0(cols="12" v-else)
            div(v-masonry="masonryIds" transition-duration="0.4s" item-selector=".item")
              div(v-masonry-tile="masonryIds" :style="masonryStyle" cols="12" md="6" v-for="(publicacion, index) in filterByTerm" :key="index").item.ma-0.pa-0
                c-noticia-v4(
                  :imagen="publicacion.imagen",
                  :titulo="publicacion.titulo",
                  :fecha="publicacion.fecha",
                  :description="publicacion.description",
                  :tipo="publicacion.tipo",
                  :archivo="publicacion.archivo"
                ).ma-2
          v-col(cols="12" v-if="pages>1 && searchTerm.length<1")
            v-pagination(v-model="page" :length="pages" :total-visible="10" color="#0B77CE" @input="updateMan" @next="updateMan" @previous="updateMan").my-4
        v-tab-item
          v-row
            v-col(cols="12" sm="12" md="6" lg="4")
              v-card
                v-card-text.pb-0
                  iframe(width="100%" height="260px" src="https://drive.google.com/file/d/10CVtG44Y2NgK1B80pirRQVrLr2SLhw1y/preview" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
                v-card-text
                  p.pa-0.ma-0.subtitle-1.font-weight-bold.text-center Recepción, revisión y asignación de subsidio,
            v-col(cols="12" sm="12" md="6" lg="4")
              v-card
                v-card-text.pb-0
                  iframe(width="100%" height="260px" src="https://www.youtube.com/embed/xBQH2WD2LF8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
                v-card-text
                  p.pa-0.ma-0.subtitle-1.font-weight-bold.text-center Registro de Formulario de Subsidio
            v-col(cols="12" sm="12" md="6" lg="4")
              v-card
                v-card-text.pb-0
                  iframe(width="100%" height="260px" src="https://www.youtube.com/embed/CtkwlGJk2pI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
                v-card-text
                  p.pa-0.ma-0.subtitle-1.font-weight-bold.text-center Registro de Experiencias Transformadoras
            v-col(cols="12" sm="12" md="6" lg="4")
              v-card
                v-card-text.pb-0
                  iframe(width="100%" height="260px" src="https://www.youtube.com/embed/6O5ujPEAa8Y" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
                v-card-text
                  p.pa-0.ma-0.subtitle-1.font-weight-bold.text-center Inscripción para el ascenso de categoría
            v-col(cols="12" sm="12" md="6" lg="4")
              v-card
                v-card-text.pb-0
                  iframe(width="100%" height="260px" src="https://www.youtube.com/embed/6O5ujPEAa8Y" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
                v-card-text
                  p.pa-0.ma-0.subtitle-1.font-weight-bold.text-center Generación de memorándums de designación, para permutas voluntarias
            v-col(cols="12" sm="8" md="6" lg="4")
              v-card
                v-card-text.pb-0
                  iframe(width="100%" height="260px" src="https://www.youtube.com/embed/NGBHvgf5YY4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
                v-card-text
                  p.pa-0.ma-0.subtitle-1.font-weight-bold.text-center Tutorial mis documentos
            v-col(cols="12" sm="8" md="6" lg="4")
              v-card
                v-card-text.pb-0
                  iframe(width="100%" height="260px" src="https://www.youtube.com/embed/grLupschlLM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
                v-card-text
                  p.pa-0.ma-0.subtitle-1.font-weight-bold.text-center Sistema SISEP - Registro Docente Administrativo
            v-col(cols="12" sm="8" md="6" lg="4")
              v-card
                v-card-text.pb-0
                  iframe(width="100%" height="260px" src="https://www.youtube.com/embed/AyyIjFGLj_w" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
                v-card-text
                  p.pa-0.ma-0.subtitle-1.font-weight-bold.text-center Impresión de boleta de inscripción, para el Ascenso de Categoría
            v-col(cols="12" sm="8" md="6" lg="4")
              v-card
                v-card-text.pb-0
                  iframe(width="100%" height="260px" src="https://www.youtube.com/embed/Zsy5KykLfPA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
                v-card-text
                  p.pa-0.ma-0.subtitle-1.font-weight-bold.text-center Impresión de butacas, ascenso de categoria
        v-tab-item
          v-row
            v-col(cols="12").text-center.pb-4.pt-10
              //-p.pa-0.ma-0(style="font-size:24px;line-height:28px;").font-weight-light BIBLIOGRAFÍA ASCENSO DE CATEGORÍA 2022
              p.pa-0.ma-0(style="font-size:24px;line-height:28px;").font-weight-light
                span(style="color:#0652a1") BIBLIOGRAFÍA
                | &nbsp;ASCENSO DE CATEGORÍA 2023
            v-col(cols="12").pt-0.pb-0
              v-tabs(background-color="transparent" color="#0652a1" v-model="currentTabBiblio" slider-size="3" slider-color="#0652a1" height="64" centered)
                v-tab(style="width:180px").pl-1.pr-1 Subsistema de Educación regular
                //-v-tab(style="width:180px").pl-1.pr-1 Subsistema de educación especial y alternativa
                //-v-tab(style="width:300px").pl-1.pr-1 Subsistema de Educación superior técnica, tecnológica, lingüistica y artística
                v-tab(style="width:300px").pl-1.pr-1 Administrativos Educación Regular
                //-v-tab(style="width:300px").pl-1.pr-1 Administrativos Regular y Alternativa
                //-v-tab Videos
                //-v-tab Bibliografías
            v-col(cols="12" style="width:100%;height:2px;background-color:#0652a1;").pa-0.ma-0
            v-col(cols="12").pt-0
              v-tabs-items(v-model="currentTabBiblio" style="width:100%").ma-0.pa-0
                v-tab-item.ma-0.pa-0(style="width:100%;height:100%")
                  v-card(color="transparent" flat).mt-4.mb-2
                    v-card-text.pb-0.ma-0.pt-1.pl-2
                      c-ascenso-regular
                v-tab-item.ma-0.pa-0(style="width:100%;height:100%")
                  v-card(color="transparent" flat).mt-4.mb-2
                    v-card-text.pb-0.ma-0.pt-1.pl-2
                      c-ascenso-administrativos
                //-v-tab-item.ma-0.pa-0(style="width:100%;height:100%")
                  v-card(color="transparent" flat).mt-4.mb-2
                    v-card-text.pb-0.ma-0.pt-1.pl-2
                      //-- PART
                      v-row(no-gutters)
                        v-col(cols="auto" style="width:56px;").pa-0
                          p.pa-0.ma-0.font-weight-bold.pb-1(style="text-align:right;font-size:16px;color:#0652a1") 1.
                        v-col
                          p.pa-0.ma-0.font-weight-bold.pb-1.ml-1(style="font-size:16px;color:#0652a1") NORMATIVA GENERAL
                      v-card(color="transparent" flat)
                        v-card-text.pa-0.pb-2
                          v-card(color="transparent" v-for="(item, index) in regular.normativaGeneral" :key="index" flat)
                            v-card-text.pa-0.ma-0
                              v-row(no-gutters v-if="item.archivo")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 1.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+item.archivo.url") (descargar)
                              v-row(no-gutters v-else-if="item.link")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 1.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="item.link") (descargar)
                              v-row(no-gutters v-else)
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 1.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                      //-- PART
                      v-row(no-gutters)
                        v-col(cols="auto" style="width:56px;").pa-0
                          p.pa-0.ma-0.font-weight-bold.pb-1(style="text-align:right;font-size:16px;color:#0652a1") 2.
                        v-col
                          p.pa-0.ma-0.font-weight-bold.pb-1.ml-1(style="font-size:16px;color:#0652a1") CALIDAD EDUCATIVA
                      v-card(color="transparent" flat)
                        v-card-text.pa-0.pb-2
                          v-card(color="transparent" v-for="(item, index) in regular.calidadEducativa" :key="index" flat)
                            v-card-text.pa-0.ma-0
                              v-row(no-gutters v-if="item.archivo")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 2.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+item.archivo.url") (descargar)
                              v-row(no-gutters v-else-if="item.link")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 2.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="item.link") (descargar)
                              v-row(no-gutters v-else)
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 2.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                      //-- PART
                      v-row(no-gutters)
                        v-col(cols="auto" style="width:56px;").pa-0
                          p.pa-0.ma-0.font-weight-bold.pb-1(style="text-align:right;font-size:16px;color:#0652a1") 3.
                        v-col
                          p.pa-0.ma-0.font-weight-bold.pb-1.ml-1(style="font-size:16px;color:#0652a1") NORMATIVA ESPECÍFICA - SUBSISTEMA DE EDUCACIÓN REGULAR
                      v-card(color="transparent" flat)
                        v-card-text.pa-0.pb-2
                          v-card(color="transparent" v-for="(item, index) in regular.normativaEspecifica" :key="index" flat)
                            v-card-text.pa-0.ma-0
                              v-row(no-gutters v-if="item.archivo")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 3.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+item.archivo.url") (descargar)
                              v-row(no-gutters v-else-if="item.link")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 3.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="item.link") (descargar)
                              v-row(no-gutters v-else)
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 3.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                      //-- PART
                      v-row(no-gutters)
                        v-col(cols="auto" style="width:56px;").pa-0
                          p.pa-0.ma-0.font-weight-bold.pb-1(style="text-align:right;font-size:16px;color:#0652a1") 4.
                        v-col
                          p.pa-0.ma-0.font-weight-bold.pb-1.ml-1(style="font-size:16px;color:#0652a1") BIBLIOGRAFÍA EDUCACIÓN INICIAL EN FAMILIA COMUNITARIA
                      v-card(color="transparent" flat)
                        v-card-text.pa-0.pb-2
                          v-card(color="transparent" v-for="(item, index) in regular.educacionInicial" :key="index" flat)
                            v-card-text.pa-0.ma-0
                              v-row(no-gutters v-if="item.archivo")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 4.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+item.archivo.url") (descargar)
                              v-row(no-gutters v-else-if="item.link")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 4.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="item.link") (descargar)
                              v-row(no-gutters v-else)
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 4.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                      //-- PART
                      v-row(no-gutters)
                        v-col(cols="auto" style="width:56px;").pa-0
                          p.pa-0.ma-0.font-weight-bold.pb-1(style="text-align:right;font-size:16px;color:#0652a1") 5.
                        v-col
                          p.pa-0.ma-0.font-weight-bold.pb-1.ml-1(style="font-size:16px;color:#0652a1") BIBLIOGRAFÍA EDUCACIÓN PRIMARIA COMUNITARIA VOCACIONAL
                      v-card(color="transparent" flat)
                        v-card-text.pa-0.pb-2
                          v-card(color="transparent" v-for="(item, index) in regular.educacionPrimaria" :key="index" flat)
                            v-card-text.pa-0.ma-0
                              v-row(no-gutters v-if="item.archivo")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 5.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+item.archivo.url") (descargar)
                              v-row(no-gutters v-else-if="item.link")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 5.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="item.link") (descargar)
                              v-row(no-gutters v-else)
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 5.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                      //-- PART
                      v-row(no-gutters)
                        v-col(cols="auto" style="width:56px;").pa-0
                          p.pa-0.ma-0.font-weight-bold.pb-1(style="text-align:right;font-size:16px;color:#0652a1") 6.
                        v-col
                          p.pa-0.ma-0.font-weight-bold.pb-1.ml-1(style="font-size:16px;color:#0652a1") BIBLIOGRAFÍA EDUCACIÓN SECUNDARIA COMUNITARIA PRODUCTIVA
                      v-card(color="transparent" flat)
                        v-card-text.pa-0.pb-2
                          v-row(no-gutters)
                            v-col(cols="auto" style="width:56px;").pa-0
                              p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#555555") 6.1.
                            v-col
                              p.pa-0.ma-0.font-weight-bold.ml-1(style="font-size:16px;color:#555555") NORMATIVA GENERAL
                          v-card(color="transparent" v-for="(item, index) in regular.secNormativaGeneral" :key="index" flat)
                            v-card-text.pa-0.ma-0
                              v-row(no-gutters v-if="item.archivo")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.1.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+item.archivo.url") (descargar)
                              v-row(no-gutters v-else-if="item.link")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.1.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="item.link") (descargar)
                              v-row(no-gutters v-else)
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.1.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                      //-- PART
                      v-card(color="transparent" flat)
                        v-card-text.pa-0.pb-2
                          v-row(no-gutters)
                            v-col(cols="auto" style="width:56px;").pa-0
                              p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#555555") 6.2.
                            v-col
                              p.pa-0.ma-0.font-weight-bold.ml-1(style="font-size:16px;color:#555555") NORMATIVA ESPECÍFICA - SUBSISTEMA DE EDUCACIÓN REGULAR
                          v-card(color="transparent" v-for="(item, index) in regular.secNormativaEspecifica" :key="index" flat)
                            v-card-text.pa-0.ma-0
                              v-row(no-gutters v-if="item.archivo")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.2.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+item.archivo.url") (descargar)
                              v-row(no-gutters v-else-if="item.link")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.2.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="item.link") (descargar)
                              v-row(no-gutters v-else)
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.2.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                      //-- PART
                      v-card(color="transparent" flat)
                        v-card-text.pa-0.pb-2
                          v-row(no-gutters)
                            v-col(cols="auto" style="width:56px;").pa-0
                              p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#555555") 6.3.
                            v-col
                              p.pa-0.ma-0.font-weight-bold.ml-1(style="font-size:16px;color:#555555") ÁREA DE CIENCIAS NATURALES: BIOLOGÍA – GEOGRAFÍA
                          v-card(color="transparent" v-for="(item, index) in regular.secCienciasNaturales" :key="index" flat)
                            v-card-text.pa-0.ma-0
                              v-row(no-gutters v-if="item.archivo")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.3.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+item.archivo.url") (descargar)
                              v-row(no-gutters v-else-if="item.link")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.3.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="item.link") (descargar)
                              v-row(no-gutters v-else)
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.3.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                      //-- PART
                      v-card(color="transparent" flat)
                        v-card-text.pa-0.pb-2
                          v-row(no-gutters)
                            v-col(cols="auto" style="width:56px;").pa-0
                              p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#555555") 6.4.
                            v-col
                              p.pa-0.ma-0.font-weight-bold.ml-1(style="font-size:16px;color:#555555") ÁREA DE CIENCIAS SOCIALES
                          v-card(color="transparent" v-for="(item, index) in regular.secCienciasSociales" :key="index" flat)
                            v-card-text.pa-0.ma-0
                              v-row(no-gutters v-if="item.archivo")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.4.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+item.archivo.url") (descargar)
                              v-row(no-gutters v-else-if="item.link")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.4.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="item.link") (descargar)
                              v-row(no-gutters v-else)
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.4.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                      //-- PART
                      v-card(color="transparent" flat)
                        v-card-text.pa-0.pb-2
                          v-row(no-gutters)
                            v-col(cols="auto" style="width:56px;").pa-0
                              p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#555555") 6.5.
                            v-col
                              p.pa-0.ma-0.font-weight-bold.ml-1(style="font-size:16px;color:#555555") ÁREA DE COMUNICACIÓN Y LENGUAJES
                          v-card(color="transparent" v-for="(item, index) in regular.secComunicacionYLenguajes" :key="index" flat)
                            v-card-text.pa-0.ma-0
                              v-row(no-gutters v-if="item.archivo")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.5.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+item.archivo.url") (descargar)
                              v-row(no-gutters v-else-if="item.link")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.5.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="item.link") (descargar)
                              v-row(no-gutters v-else)
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.5.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                      //-- PART
                      v-card(color="transparent" flat)
                        v-card-text.pa-0.pb-2
                          v-row(no-gutters)
                            v-col(cols="auto" style="width:56px;").pa-0
                              p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#555555") 6.6.
                            v-col
                              p.pa-0.ma-0.font-weight-bold.ml-1(style="font-size:16px;color:#555555") ÁREA: COSMOVISIONES, FILOSOFÍA Y SICOLOGÍA
                          v-card(color="transparent" v-for="(item, index) in regular.secCosmovisiones" :key="index" flat)
                            v-card-text.pa-0.ma-0
                              v-row(no-gutters v-if="item.archivo")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.6.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+item.archivo.url") (descargar)
                              v-row(no-gutters v-else-if="item.link")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.6.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="item.link") (descargar)
                              v-row(no-gutters v-else)
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.6.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                      //-- PART
                      v-card(color="transparent" flat)
                        v-card-text.pa-0.pb-2
                          v-row(no-gutters)
                            v-col(cols="auto" style="width:56px;").pa-0
                              p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#555555") 6.7.
                            v-col
                              p.pa-0.ma-0.font-weight-bold.ml-1(style="font-size:16px;color:#555555") ÁREA: FÍSICA
                          v-card(color="transparent" v-for="(item, index) in regular.secFisica" :key="index" flat)
                            v-card-text.pa-0.ma-0
                              v-row(no-gutters v-if="item.archivo")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.7.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+item.archivo.url") (descargar)
                              v-row(no-gutters v-else-if="item.link")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.7.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="item.link") (descargar)
                              v-row(no-gutters v-else)
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.7.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                      //-- PART
                      v-card(color="transparent" flat)
                        v-card-text.pa-0.pb-2
                          v-row(no-gutters)
                            v-col(cols="auto" style="width:56px;").pa-0
                              p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#555555") 6.8.
                            v-col
                              p.pa-0.ma-0.font-weight-bold.ml-1(style="font-size:16px;color:#555555") ÁREA: QUÍMICA
                          v-card(color="transparent" v-for="(item, index) in regular.secQuimica" :key="index" flat)
                            v-card-text.pa-0.ma-0
                              v-row(no-gutters v-if="item.archivo")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.8.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+item.archivo.url") (descargar)
                              v-row(no-gutters v-else-if="item.link")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.8.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="item.link") (descargar)
                              v-row(no-gutters v-else)
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.8.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                      //-- PART
                      v-card(color="transparent" flat)
                        v-card-text.pa-0.pb-2
                          v-row(no-gutters)
                            v-col(cols="auto" style="width:56px;").pa-0
                              p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#555555") 6.9.
                            v-col
                              p.pa-0.ma-0.font-weight-bold.ml-1(style="font-size:16px;color:#555555") ÁREA: TÉCNICA TECNOLÓGICA
                          v-card(color="transparent" v-for="(item, index) in regular.secTecnicaTecnologica" :key="index" flat)
                            v-card-text.pa-0.ma-0
                              v-row(no-gutters v-if="item.archivo")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.9.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+item.archivo.url") (descargar)
                              v-row(no-gutters v-else-if="item.link")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.9.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="item.link") (descargar)
                              v-row(no-gutters v-else)
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.9.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                      //-- PART
                      v-card(color="transparent" flat)
                        v-card-text.pa-0.pb-2
                          v-row(no-gutters)
                            v-col(cols="auto" style="width:56px;").pa-0
                              p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#555555") 6.10.
                            v-col
                              p.pa-0.ma-0.font-weight-bold.ml-1(style="font-size:16px;color:#555555") ÁREA: VALORES, ESPIRITUALIDAD Y RELIGIONES
                          v-card(color="transparent" v-for="(item, index) in regular.secValores" :key="index" flat)
                            v-card-text.pa-0.ma-0
                              v-row(no-gutters v-if="item.archivo")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.10.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+item.archivo.url") (descargar)
                              v-row(no-gutters v-else-if="item.link")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.10.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="item.link") (descargar)
                              v-row(no-gutters v-else)
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.10.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                      //-- PART
                      v-card(color="transparent" flat)
                        v-card-text.pa-0.pb-2
                          v-row(no-gutters)
                            v-col(cols="auto" style="width:56px;").pa-0
                              p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#555555") 6.11.
                            v-col
                              p.pa-0.ma-0.font-weight-bold.ml-1(style="font-size:16px;color:#555555") ÁREA DE LENGUA EXTRANJERA
                          v-card(color="transparent" v-for="(item, index) in regular.secLenguaExtranjera" :key="index" flat)
                            v-card-text.pa-0.ma-0
                              v-row(no-gutters v-if="item.archivo")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.11.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+item.archivo.url") (descargar)
                              v-row(no-gutters v-else-if="item.link")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.11.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="item.link") (descargar)
                              v-row(no-gutters v-else)
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.11.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                      //-- PART
                      v-card(color="transparent" flat)
                        v-card-text.pa-0.pb-2
                          v-row(no-gutters)
                            v-col(cols="auto" style="width:56px;").pa-0
                              p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#555555") 6.12.
                            v-col
                              p.pa-0.ma-0.font-weight-bold.ml-1(style="font-size:16px;color:#555555") ÁREA: EDUCACIÓN MUSICAL
                          v-card(color="transparent" v-for="(item, index) in regular.secEducacionMusical" :key="index" flat)
                            v-card-text.pa-0.ma-0
                              v-row(no-gutters v-if="item.archivo")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.12.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+item.archivo.url") (descargar)
                              v-row(no-gutters v-else-if="item.link")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.12.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="item.link") (descargar)
                              v-row(no-gutters v-else)
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.12.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                      //-- PART
                      v-card(color="transparent" flat)
                        v-card-text.pa-0.pb-2
                          v-row(no-gutters)
                            v-col(cols="auto" style="width:56px;").pa-0
                              p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#555555") 6.13.
                            v-col
                              p.pa-0.ma-0.font-weight-bold.ml-1(style="font-size:16px;color:#555555") ÁREA: MATEMÁTICA
                          v-card(color="transparent" v-for="(item, index) in regular.secMatematica" :key="index" flat)
                            v-card-text.pa-0.ma-0
                              v-row(no-gutters v-if="item.archivo")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.13.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+item.archivo.url") (descargar)
                              v-row(no-gutters v-else-if="item.link")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.13.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="item.link") (descargar)
                              v-row(no-gutters v-else)
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.13.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                      //-- PART
                      v-card(color="transparent" flat)
                        v-card-text.pa-0.pb-2
                          v-row(no-gutters)
                            v-col(cols="auto" style="width:56px;").pa-0
                              p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#555555") 6.14.
                            v-col
                              p.pa-0.ma-0.font-weight-bold.ml-1(style="font-size:16px;color:#555555") ÁREA DE ARTES PLÁSTICAS Y VISUALES
                          v-card(color="transparent" v-for="(item, index) in regular.secArtesPlasticas" :key="index" flat)
                            v-card-text.pa-0.ma-0
                              v-row(no-gutters v-if="item.archivo")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.14.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+item.archivo.url") (descargar)
                              v-row(no-gutters v-else-if="item.link")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.14.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="item.link") (descargar)
                              v-row(no-gutters v-else)
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.14.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                      //-- PART
                      v-card(color="transparent" flat)
                        v-card-text.pa-0.pb-2
                          v-row(no-gutters)
                            v-col(cols="auto" style="width:56px;").pa-0
                              p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#555555") 6.15.
                            v-col
                              p.pa-0.ma-0.font-weight-bold.ml-1(style="font-size:16px;color:#555555") ÁREA: EDUCACIÓN FÍSICA Y DEPORTES
                          v-card(color="transparent" v-for="(item, index) in regular.secEducacionFisica" :key="index" flat)
                            v-card-text.pa-0.ma-0
                              v-row(no-gutters v-if="item.archivo")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.15.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+item.archivo.url") (descargar)
                              v-row(no-gutters v-else-if="item.link")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.15.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="item.link") (descargar)
                              v-row(no-gutters v-else)
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 6.15.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                //- ENDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDD
                v-tab-item.ma-0.pa-0(style="width:100%;height:100%")
                  v-card(color="transparent" v-for="(item, index) in bibliografiaEducacionAyE" :key="index" flat).mt-4.mb-2
                    v-card-text.pb-0.ma-0.pt-1.pl-2
                      v-row(no-gutters)
                        v-col(cols="auto" style="width:56px;").pa-0
                          p.pa-0.ma-0.font-weight-bold.pb-1(style="text-align:right;font-size:16px;color:#0652a1") {{ (index+1) }}.
                        v-col
                          p.pa-0.ma-0.font-weight-bold.pb-1.ml-1(style="font-size:16px;color:#0652a1") {{item.grupo}}
                      v-card(color="transparent" v-for="(item2, index2) in item.subgrupos" :key="index2" flat)
                        v-card-text.pa-0.pb-2
                          v-row(no-gutters)
                            v-col(cols="auto" style="width:56px;").pa-0
                              p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#555555") {{ (index+1) }}.{{index2+1}}.
                            v-col
                              p.pa-0.ma-0.font-weight-bold.ml-1(style="font-size:16px;color:#555555") {{ item2.subgrupo}}
                          v-card(color="transparent" v-for="(item3, index3) in item2.bibliografias" :key="index3" flat)
                            v-card-text.pa-0.ma-0
                              v-row(no-gutters v-if="item3.archivo")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") {{ (index+1) }}.{{index2+1}}.{{index3+1}}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item3.item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+item3.archivo.url") (descargar)
                              v-row(no-gutters v-else)
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") {{ (index+1) }}.{{index2+1}}.{{index3+1}}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item3.item }}
                  //-v-card(color="blue" v-else).mb-2
                    v-card-text
                      span Cargando...
                v-tab-item.ma-0.pa-0(style="width:100%;height:100%")
                  v-card(color="transparent" flat).mt-4.mb-2
                    //- SUPPPPPPP WITH BIG TITLE
                    v-card-text.pb-0.ma-0.pt-1.pl-2
                      v-row(no-gutters)
                        v-col(cols="auto" style="width:62px;").pa-0
                          p.pa-0.ma-0.font-weight-bold.pb-1(style="text-align:right;font-size:16px;color:#0652a1") 1.
                        v-col
                          p.pa-0.ma-0.font-weight-bold.pb-1.ml-1(style="font-size:16px;color:#0652a1") EDUCACIÓN TÉCNICA Y TECNOLÓGICA
                      v-card(color="transparent" flat v-for="(item, index) in superior" :key="index")
                        v-card-text.pa-0.pb-2
                          v-row(no-gutters)
                            v-col(cols="auto" style="width:62px;").pa-0
                              p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#555555") 1.{{ index+1 }}.
                            v-col
                              p.pa-0.ma-0.font-weight-bold.ml-1(style="font-size:16px;color:#555555") {{ item.name }}
                          v-card(color="transparent" flat)
                            v-card-text.pa-0.ma-0(v-for="(aitem, aindex) in item.items" :key="aindex")
                              v-row(no-gutters)
                                v-col(cols="auto" style="width:62px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 1.{{ index+1 }}.{{ aindex+1 }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000" v-if="aitem.Archivo") {{ aitem.Item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+aitem.Archivo.url") (descargar)
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000" v-else) {{ aitem.Item }}
                    //- SUPPPPPPP WITH BIG TITLE
                    v-card-text.pb-0.ma-0.pt-1.pl-2
                      v-row(no-gutters)
                        v-col(cols="auto" style="width:62px;").pa-0
                          p.pa-0.ma-0.font-weight-bold.pb-1(style="text-align:right;font-size:16px;color:#0652a1") 2.
                        v-col
                          p.pa-0.ma-0.font-weight-bold.pb-1.ml-1(style="font-size:16px;color:#0652a1") EDUCACIÓN SUPERIOR ARTÍSTICA
                      v-card(color="transparent" flat v-for="(item, index) in superiorArt" :key="index")
                        v-card-text.pa-0.pb-2
                          v-row(no-gutters)
                            v-col(cols="auto" style="width:62px;").pa-0
                              p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#555555") 2.{{ index+1 }}.
                            v-col
                              p.pa-0.ma-0.font-weight-bold.ml-1(style="font-size:16px;color:#555555") {{ item.name }}
                          v-card(color="transparent" flat)
                            v-card-text.pa-0.ma-0(v-for="(aitem, aindex) in item.items" :key="aindex")
                              v-row(no-gutters)
                                v-col(cols="auto" style="width:62px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 2.{{ index+1 }}.{{ aindex+1 }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000" v-if="aitem.Archivo") {{ aitem.Item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+aitem.Archivo.url") (descargar)
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000" v-else) {{ aitem.Item }}
                      //- SUPPPPPPP
                      //- SUPPPPPPP
                      //-v-card-text.pb-0.ma-0.pt-1.pl-2
                      //-v-card(color="transparent" flat)
                        v-card-text.pa-0.pb-2
                          v-row(no-gutters)
                            v-col(cols="auto" style="width:56px;").pa-0
                              p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#555555") 1.2.
                            v-col
                              p.pa-0.ma-0.font-weight-bold.ml-1(style="font-size:16px;color:#555555") NORMATIVA GENERAL
                          v-card(color="transparent" flat)
                            v-card-text.pa-0.ma-0(v-for="(aitem, aindex) in superior[1]" :key="aindex")
                              v-row(no-gutters)
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 1.2.{{ aindex+1 }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000" v-if="aitem.Archivo") {{ aitem.Item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+aitem.Archivo.url") (descargar)
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000" v-else) {{ aitem.Item }}
                    
                    //-v-card-text.pb-0.ma-0.pt-1.pl-2
                      v-card(color="transparent" flat)
                        v-card-text.pa-0.pb-2
                          v-row(no-gutters)
                            v-col(cols="auto" style="width:56px;").pa-0
                              p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#555555") 1.2.
                            v-col
                              p.pa-0.ma-0.font-weight-bold.ml-1(style="font-size:16px;color:#555555") NORMATIVA GENERAL
                          v-card(color="transparent" flat)
                            v-card-text.pa-0.ma-0(v-for="(aitem, aindex) in superior[4]" :key="aindex")
                              v-row(no-gutters)
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 1.2.{{ aindex+1 }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000" v-if="aitem.Archivo") {{ aitem.Item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+aitem.Archivo.url") (descargar)
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000" v-else) {{ aitem.Item }}
                v-tab-item.ma-0.pa-0(style="width:100%;height:100%")
                  v-card(color="transparent" flat).mt-4.mb-2
                    v-card-text.pb-0.ma-0.pt-1.pl-2
                      //-- PART
                      v-row(no-gutters)
                        v-col(cols="auto" style="width:56px;").pa-0
                          p.pa-0.ma-0.font-weight-bold.pb-1(style="text-align:right;font-size:16px;color:#0652a1") 1.
                        v-col
                          p.pa-0.ma-0.font-weight-bold.pb-1.ml-1(style="font-size:16px;color:#0652a1") NORMATIVA GENERAL
                      v-card(color="transparent" flat)
                        v-card-text.pa-0.pb-2
                          v-card(color="transparent" v-for="(item, index) in regular.normativaGeneral" :key="index" flat)
                            v-card-text.pa-0.ma-0
                              v-row(no-gutters v-if="item.archivo")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 1.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+item.archivo.url") (descargar)
                              v-row(no-gutters v-else-if="item.link")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 1.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="item.link") (descargar)
                              v-row(no-gutters v-else)
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 1.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                      //-- PART
                      v-row(no-gutters)
                        v-col(cols="auto" style="width:56px;").pa-0
                          p.pa-0.ma-0.font-weight-bold.pb-1(style="text-align:right;font-size:16px;color:#0652a1") 2.
                        v-col
                          p.pa-0.ma-0.font-weight-bold.pb-1.ml-1(style="font-size:16px;color:#0652a1") CALIDAD EDUCATIVA
                      v-card(color="transparent" flat)
                        v-card-text.pa-0.pb-2
                          v-card(color="transparent" v-for="(item, index) in regular.calidadEducativa" :key="index" flat)
                            v-card-text.pa-0.ma-0
                              v-row(no-gutters v-if="item.archivo")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 2.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="'/strapi/strapi-portal'+item.archivo.url") (descargar)
                              v-row(no-gutters v-else-if="item.link")
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 2.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
                                    a.blue--text(target="_blank" :href="item.link") (descargar)
                              v-row(no-gutters v-else)
                                v-col(cols="auto" style="width:56px;").pa-0
                                  p.pa-0.ma-0.font-weight-bold(style="text-align:right;font-size:16px;color:#000") 2.{{ (index+1) }}.
                                v-col
                                  p.pa-0.ma-0.ml-1(style="font-size:16px;color:#000") {{ item.item }}
        v-tab-item
          v-row(dense).pl-2.pr-2
            v-col(cols="12").text-center.pb-4.pt-8
              p.pa-0.ma-0(style="font-size:24px;line-height:28px;").font-weight-light
                apan(style="color:#0652a1;") DIRECTRICES
                | &nbsp;ASCENSO DE CATEGORÍA 2022
            v-col(cols="12" md="6")
              v-card.pb-3
                v-card-text.pb-2
                  p.text-center(style="max-width:400px;margin:0px auto;") DIRECTRICES PARA LA ELABORACIÓN DE LAS EXPERIENCIAS TRANSFORMADORAS GESTIÓN 2022<br>PERSONAL DOCENTE
                v-card-text.pt-0.pb-0
                  iframe(src="https://cdn.jsdelivr.net/gh/ugpsep/assets/directrices/EET-2022-DOCENTE_compressed.pdf#zoom=FitH" style="width:100%;height:380px;")
                v-card-actions.mt-2
                  v-spacer
                  v-btn(href="https://github.com/ugpsep/assets/raw/main/directrices/EET-2022-DOCENTE_compressed.pdf" target="_blank" color="#0652a1" dark) Descargar
                  v-spacer
            v-col(cols="12" md="6").pb-8
              v-card.pb-3
                v-card-text.pb-2
                  p.text-center(style="max-width:400px;margin:0px auto;") DIRECTRICES PARA LA ELABORACIÓN DE LAS EXPERIENCIAS TRANSFORMADORAS GESTIÓN 2022<br>PERSONAL ADMINISTRATIVO
                v-card-text.pt-0.pb-0
                  iframe(src="https://cdn.jsdelivr.net/gh/ugpsep/assets/directrices/EET-2022-ADMIN.pdf#zoom=FitH" style="width:100%;height:380px;")
                v-card-actions.mt-2
                  v-spacer
                  v-btn(href="https://github.com/ugpsep/assets/raw/main/directrices/EET-2022-ADMIN.pdf" target="_blank" color="#0652a1" dark) Descargar
                  v-spacer
  v-dialog(v-model="dialogoPrecarga" max-width="400" v-on:click:outside="cancelarPrecarga")
    v-card(flat color="blue" style="background-image:linear-gradient(to bottom, #2b5b84, #1e415e)")
      v-card-text.text-center.pa-0
        v-progress-circular(:rotate="270" :size="80" :width="5" :value="value" color="orange" style="margin: 2rem").ma-5
          span.white--text {{ value }} %
      v-card-text.text-center.pa-5.pt-0
        h3.white--text Cargando Formulario...
  v-dialog(v-model="dialogoFormulario" fullscreen)
    v-card(flat).rounded-0
      v-card-title.no-padding
        v-toolbar(dark style="background-image: linear-gradient(#1e415e 10%,#2b5b84 90%);")
            v-btn(color="white" outlined style="border-radius:5px;" @click="dialogoFormulario = false").pl-3.pr-3.rounded-lg
                v-icon(size="15") fas fa-arrow-left
                | &nbsp;Volver
      v-card-text.pa-2(:style="customHeight")
        iframe(:src="theLink" width="100%" height="100%" style="overflow:hidden;" frameborder="0")
</template>

<style lang="stylus">
.wallpaper
  //background url("/img/fox-tail2.png") top -390px center no-repeat, #000428
  background #000428
  margin-top 92px
  box-shadow 0px 0px 10px 0px rgba(0,0,0,0.18) !important
  margin-top 260px
.login-panel
  margin-top -60px
  background-image:linear-gradient(to bottom, #2b5b84, #1e415e)
@media screen and (max-width: 960px)
  .login-panel
    margin-top -5px
  .wallpaper
    margin-top 170px
</style>


<script>
import { arrayExpression } from 'babel-types';
import Vue from 'vue'
export default {
  data() {
    return {
      items: [
        { title: 'Chuquisaca',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reportePorParametrosYDepartamento/1' },
        { title: 'La Paz',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reportePorParametrosYDepartamento/2' },
        { title: 'Cochabamba',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reportePorParametrosYDepartamento/3' },
        { title: 'Oruro',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reportePorParametrosYDepartamento/4' },
        { title: 'Potosí',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reportePorParametrosYDepartamento/5' },
        { title: 'Tarija',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reportePorParametrosYDepartamento/6' },
        { title: 'Santa Cruz',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reportePorParametrosYDepartamento/7' },
        { title: 'Beni',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reportePorParametrosYDepartamento/8' },
        { title: 'Pando',ref:'https://sisep.minedu.gob.bo/db-service/db-service-reportes-abms/api/v1/servicio_reportes_abms/moduloReporteCompulsa/reportePorParametrosYDepartamento/9' },
      ],
      bibliografias:[],
      bibliografiasParsed:[],
      bibliografiaEducacionAyE:[],
      bibliografiasPart2:[],
      bibliografiasPart3:[],
      currentTab: 2,
      currentTabBiblio:1,
      regular:{
        normativaGeneral:[],
        calidadEducativa:[],
        normativaEspecifica:[],
        educacionInicial:[],
        educacionPrimaria:[],
        secNormativaGeneral:[],
        secNormativaEspecifica:[],
        secCienciasNaturales:[],
        secCienciasSociales:[],
        secComunicacionYLenguajes:[],
        secCosmovisiones:[],
        secFisica:[],
        secQuimica:[],
        secTecnicaTecnologica:[],
        secValores:[],
        secLenguaExtranjera:[],
        secEducacionMusical:[],
        secMatematica:[],
        secArtesPlasticas:[],
        secEducacionFisica:[],
      },
      superior:[],
      superiorArt:[],
      masonryId: 'masonry-grid-1',
      masonryIds: 'masonry-grid-2',
      searchTerm: "",
      pages: 1,
      page: 1,
      limitPerPage: 12,
      banners: [],
      publicaciones: [],
      dialogoPrecarga: false,
      dialogoFormulario: false,
      interval:{},
      value: 0,
      time: null,
      theLink: "/ui/ui-distrito/sin-usuario/inscripcion-a-compulsa" + "?ver=" + (Math.random() * (9999999 - 999) + 999)
    }
  },
  async mounted(){
    try {
      let getPublicaciones = await axios.get("/strapi/strapi-portal/publicacions?_sort=created_at:DESC");
      //let getPublicaciones = await axios.get("http://100.0.102.26:8103/publicacions?_sort=created_at:DESC");
      const tmpPublicacion = [];
      for (let i = 0; i < getPublicaciones.data.length; i++) {
        const element = getPublicaciones.data[i];
        tmpPublicacion.push({
          imagen: "/strapi/strapi-portal" + element.imagen.url,
          titulo: element.titulo,
          fecha: this.$store.state.formatFecha(element.fecha),
          description: element.descripcion,
          tipo: element.tipo,
          archivo: "/strapi/strapi-portal" + element.archivo.url
        })
      }
      this.publicaciones = tmpPublicacion;
      this.pages = Math.ceil((this.publicaciones.length/this.limitPerPage))
      let getBanners = await axios.get("/strapi/strapi-portal/banners?_sort=created_at:DESC");
      //let getBanners = await axios.get("http://100.0.102.26:8103/banners?_sort=created_at:DESC");
      const tmpBanners = [];
      for (let j = 0; j < getBanners.data.length; j++) {
        const element2 = getBanners.data[j];
        if(element2.estado == true){
          tmpBanners.push({
            imagen: "/strapi/strapi-portal" + element2.imagen.url,
            link: element2.link
          });
        }
      }
      this.banners = tmpBanners;
    } catch (error) {
      this.$snotify.simple("No se pudo obtener datos del servidor :(", {
        timeout: 10000
      })
      console.log(error)
    }
  },
  computed:{
    customHeight: function() {
      return (
        "height:" +
        (this.$store.state.windowSize.h - 64) +
        "px;overflow:hidden;width:100%;background-image: linear-gradient(#1e415e 10%,#2b5b84 90%);"
      );
    },
    masonryStyle() {
      return (this.$store.state.windowSize.w < 800) ? "width:100%" : "width:50%"
    },
    filterByTerm(){
      return this.publicaciones.filter(publicacion => {
        return publicacion.titulo.toUpperCase().includes(this.searchTerm.toUpperCase());
      });
    }
  },
  methods:{
    /*async makeb(){
      try{
        let url="/strapi/strapi-portal/bibliografias?_sort=created_at:ASC&subsistema.nombre=EDUCACI%C3%93N%20SUPERIOR%20T%C3%89CNICA,%20TECNOL%C3%93GICA,%20LING%C3%9CISTICA%20Y%20ART%C3%8DSTICA&grupo.nombre=BIBLIOGRAF%C3%8DA%20DE%20EDUCACI%C3%93N%20SUPERIOR%20T%C3%89CNICA%20TECNOL%C3%93GICA&subgrupo.nombre="+name;
        return [1,2,3,4,5,6];
      }
      catch(error){
        this.$snotify.info(error);
      }
    },*/
    async loadSuperior(){
      try{
        let urlf = "/strapi/strapi-portal/subgrupos?_sort=created_at:ASC&subsistema.nombre=EDUCACI%C3%93N%20SUPERIOR%20T%C3%89CNICA,%20TECNOL%C3%93GICA,%20LING%C3%9CISTICA%20Y%20ART%C3%8DSTICA&grupo.nombre=BIBLIOGRAFÍA%20DE%20EDUCACIÓN%20SUPERIOR%20TÉCNICA%20TECNOLÓGICA";
        //let urlf = "http://100.0.102.26:8103/subgrupos?_sort=created_at:ASC&subsistema.nombre=EDUCACI%C3%93N%20SUPERIOR%20T%C3%89CNICA,%20TECNOL%C3%93GICA,%20LING%C3%9CISTICA%20Y%20ART%C3%8DSTICA&grupo.nombre=BIBLIOGRAFÍA%20DE%20EDUCACIÓN%20SUPERIOR%20TÉCNICA%20TECNOLÓGICA";

        let url="/strapi/strapi-portal/bibliografias?_sort=created_at:ASC&subsistema.nombre=EDUCACI%C3%93N%20SUPERIOR%20T%C3%89CNICA,%20TECNOL%C3%93GICA,%20LING%C3%9CISTICA%20Y%20ART%C3%8DSTICA&grupo.nombre=BIBLIOGRAF%C3%8DA%20DE%20EDUCACI%C3%93N%20SUPERIOR%20T%C3%89CNICA%20TECNOL%C3%93GICA&subgrupo.nombre=";
        //let url="http://100.0.102.26:8103/bibliografias?_sort=created_at:ASC&subsistema.nombre=EDUCACI%C3%93N%20SUPERIOR%20T%C3%89CNICA,%20TECNOL%C3%93GICA,%20LING%C3%9CISTICA%20Y%20ART%C3%8DSTICA&grupo.nombre=BIBLIOGRAF%C3%8DA%20DE%20EDUCACI%C3%93N%20SUPERIOR%20T%C3%89CNICA%20TECNOL%C3%93GICA&subgrupo.nombre=";
        
        let superiores = (await axios.get(urlf)).data
        for (let i = 0; i < superiores.length; i++) {
          this.superior.push({
            'name': superiores[i].nombre,
            'items': (await axios.get(url + superiores[i].nombre)).data
          })
        }
      }
      catch(error){
        this.$snotify.info(error);
      }
    },
    async loadSuperiorArt(){
      try{
        let urlf = "/strapi/strapi-portal/subgrupos?_sort=created_at:ASC&subsistema.nombre=EDUCACI%C3%93N%20SUPERIOR%20T%C3%89CNICA,%20TECNOL%C3%93GICA,%20LING%C3%9CISTICA%20Y%20ART%C3%8DSTICA&grupo.nombre=BIBLIOGRAFÍA%20DE%20EDUCACIÓN%20SUPERIOR%20ARTÍSTICA";
        //let urlf = "http://100.0.102.26:8103/subgrupos?_sort=created_at:ASC&subsistema.nombre=EDUCACI%C3%93N%20SUPERIOR%20T%C3%89CNICA,%20TECNOL%C3%93GICA,%20LING%C3%9CISTICA%20Y%20ART%C3%8DSTICA&grupo.nombre=BIBLIOGRAFÍA%20DE%20EDUCACIÓN%20SUPERIOR%20ARTÍSTICA";

        let url="/strapi/strapi-portal/bibliografias?_sort=created_at:ASC&subsistema.nombre=EDUCACI%C3%93N%20SUPERIOR%20T%C3%89CNICA,%20TECNOL%C3%93GICA,%20LING%C3%9CISTICA%20Y%20ART%C3%8DSTICA&grupo.nombre=BIBLIOGRAFÍA%20DE%20EDUCACIÓN%20SUPERIOR%20ARTÍSTICA&subgrupo.nombre=";
        //let url="http://100.0.102.26:8103/bibliografias?_sort=created_at:ASC&subsistema.nombre=EDUCACI%C3%93N%20SUPERIOR%20T%C3%89CNICA,%20TECNOL%C3%93GICA,%20LING%C3%9CISTICA%20Y%20ART%C3%8DSTICA&grupo.nombre=BIBLIOGRAFÍA%20DE%20EDUCACIÓN%20SUPERIOR%20ARTÍSTICA&subgrupo.nombre=";
        
        let superioresArt = (await axios.get(urlf)).data
        for (let i = 0; i < superioresArt.length; i++) {
          this.superiorArt.push({
            'name': superioresArt[i].nombre,
            'items': (await axios.get(url + superioresArt[i].nombre)).data
          })
        }
      }
      catch(error){
        this.$snotify.info(error);
      }
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    scrollToBTabs(){
      let root = document.getElementById('scrolling-techniques-2');
      root.scrollTo({
        top: 612,
        left: 0,
        behavior: 'smooth',
      });
    },
    parseBibliografias(){
      let tmpArray = [];
      this.bibliografias.forEach(value => {
        if(value.estado == true){
          tmpArray.push(value.subsistema.nombre)
        }
      });
      tmpArray = [...new Set(tmpArray)];
      let auxArray = [];
      let aux2Array = [];
      tmpArray.forEach(value => {
        auxArray.push({'subsistema': value, 'grupos': null});
      });
      tmpArray = auxArray;
      tmpArray.forEach((value,index) => {
        auxArray = [];
        this.bibliografias.forEach(value2 => {
          if(value.subsistema == value2.subsistema.nombre && value2.estado == true){
            if(value2.grupo){
              auxArray.push(value2.grupo.nombre)
            }
          }
        });
        auxArray = [...new Set(auxArray)];
        aux2Array = [];
        auxArray.forEach(value=>{
          aux2Array.push({'grupo':value, 'subgrupos': null});
        });
        tmpArray[index].grupos = aux2Array;
      });
      tmpArray.forEach((value,index) => {
        if(value.grupos){
          value.grupos.forEach((value2,index2) => {
            auxArray = [];
            this.bibliografias.forEach(value3 => {
              if(value3.grupo){
                if(value3.subsistema.nombre == value.subsistema && value3.grupo.nombre == value2.grupo && value3.estado == true){
                  if(value3.subgrupo){
                    auxArray.push(value3.subgrupo.nombre);
                  }
                }
              }
            });
            auxArray = [...new Set(auxArray)];
            aux2Array = [];
            auxArray.forEach(value4=>{
              aux2Array.push({'subgrupo':value4,'bibliografias':null});
            });
            tmpArray[index].grupos[index2].subgrupos = aux2Array;
          });
        }
      });
      tmpArray.forEach((value,index) => {
        value.grupos.forEach((value2,index2) => {
          if(value2.subgrupos){
            value2.subgrupos.forEach((value3, index3)=>{
              auxArray = [];
              this.bibliografias.forEach(value4 => {
                if(value3.subgrupo){
                  if(value.subsistema == value4.subsistema.nombre && value2.grupo == value4.grupo.nombre && value3.subgrupo == value4.subgrupo.nombre && value4.estado == true){
                    auxArray.push({'item':value4.Item,'link':value4.link,'archivo':value4.Archivo,'estado':value4.estado});
                  }
                }
              });
              tmpArray[index].grupos[index2].subgrupos[index3].bibliografias = auxArray;
            });
          }
        });
      });
      this.bibliografiasParsed = tmpArray;
    },
    makeNormativaGeneral(biblio){
      this.regular.normativaGeneral = [];
      biblio.forEach(value => {
        if(value.estado == true){
          if(value.subsistema.nombre == "EDUCACIÓN REGULAR"){
            if(!value.grupo && value.subgrupo.nombre=="NORMATIVA GENERAL"){
              this.regular.normativaGeneral.push({'item':value.Item,'link':value.link,'archivo':value.Archivo});
            }
          }
        }
      });
    },
    makeCalidadEducativa(biblio){
      this.regular.calidadEducativa = [];
      biblio.forEach(value => {
        if(value.estado == true){
          if(value.subsistema.nombre == "EDUCACIÓN REGULAR"){
            if(!value.grupo && value.subgrupo.nombre=="CALIDAD EDUCATIVA"){
              this.regular.calidadEducativa.push({'item':value.Item,'link':value.link,'archivo':value.Archivo});
            }
          }
        }
      });
    },
    makeNormativaEspecifica(biblio){
      this.regular.normativaEspecifica = [];
      biblio.forEach(value => {
        if(value.estado == true){
          if(value.subsistema.nombre == "EDUCACIÓN REGULAR"){
            if(!value.grupo && value.subgrupo.nombre=="NORMATIVA ESPECÍFICA - SUBSISTEMA DE EDUCACIÓN REGULAR"){
              this.regular.normativaEspecifica.push({'item':value.Item,'link':value.link,'archivo':value.Archivo});
            }
          }
        }
      });
    },
    makeEducacionInicial(biblio){
      this.regular.educacionInicial = [];
      biblio.forEach(value => {
        if(value.estado == true){
          if(value.subsistema.nombre == "EDUCACIÓN REGULAR"){
            if(!value.subgrupo && value.grupo.nombre=="BIBLIOGRAFÍA EDUCACIÓN INICIAL EN FAMILIA COMUNITARIA"){
              this.regular.educacionInicial.push({'item':value.Item,'link':value.link,'archivo':value.Archivo});
            }
          }
        }
      });
    },
    makeEducacionPrimaria(biblio){
      this.regular.educacionPrimaria = [];
      biblio.forEach(value => {
        if(value.estado == true){
          if(value.subsistema.nombre == "EDUCACIÓN REGULAR"){
            if(!value.subgrupo && value.grupo.nombre=="BIBLIOGRAFÍA EDUCACIÓN PRIMARIA COMUNITARIA VOCACIONAL"){
              this.regular.educacionPrimaria.push({'item':value.Item,'link':value.link,'archivo':value.Archivo});
            }
          }
        }
      });
    },
    makeSecNormativaGeneral(biblio){
      //console.log(">>> " + biblio.length);
      this.regular.secNormativaGeneral = [];
      biblio.forEach(value => {
        if(value.estado == true){
          if(value.subsistema.nombre == "EDUCACIÓN REGULAR"){
            if(value.subgrupo.nombre="NORMATIVA GENERAL" && value.grupo.nombre=="BIBLIOGRAFÍA EDUCACIÓN SECUNDARIA COMUNITARIA PRODUCTIVA"){
              this.regular.secNormativaGeneral.push({'item':value.Item,'link':value.link,'archivo':value.Archivo});
            }
          }
        }
      });
    },
    makeSecNormativaEspecifica(biblio){
      this.regular.secNormativaEspecifica = [];
      biblio.forEach(value => {
        if(value.estado == true){
          if(value.subsistema.nombre == "EDUCACIÓN REGULAR"){
            if(value.subgrupo.nombre="NORMATIVA ESPECÍFICA - SUBSISTEMA DE EDUCACIÓN REGULAR" && value.grupo.nombre=="BIBLIOGRAFÍA EDUCACIÓN SECUNDARIA COMUNITARIA PRODUCTIVA"){
              this.regular.secNormativaEspecifica.push({'item':value.Item,'link':value.link,'archivo':value.Archivo});
            }
          }
        }
      });
    },
    makeSecCienciasNaturales(biblio){
      this.regular.secCienciasNaturales = [];
      biblio.forEach(value => {
        if(value.estado == true){
          if(value.subsistema.nombre == "EDUCACIÓN REGULAR"){
            if(value.subgrupo.nombre="ÁREA DE CIENCIAS NATURALES: BIOLOGÍA – GEOGRAFÍA" && value.grupo.nombre=="BIBLIOGRAFÍA EDUCACIÓN SECUNDARIA COMUNITARIA PRODUCTIVA"){
              this.regular.secCienciasNaturales.push({'item':value.Item,'link':value.link,'archivo':value.Archivo});
            }
          }
        }
      });
    },
    makeSecCienciasSociales(biblio){
      this.regular.secCienciasSociales = [];
      biblio.forEach(value => {
        if(value.estado == true){
          if(value.subsistema.nombre == "EDUCACIÓN REGULAR"){
            if(value.subgrupo.nombre="ÁREA DE CIENCIAS SOCIALES" && value.grupo.nombre=="BIBLIOGRAFÍA EDUCACIÓN SECUNDARIA COMUNITARIA PRODUCTIVA"){
              this.regular.secCienciasSociales.push({'item':value.Item,'link':value.link,'archivo':value.Archivo});
            }
          }
        }
      });
    },
    makeSecComunicacionYLenguajes(biblio){
      this.regular.secComunicacionYLenguajes = [];
      biblio.forEach(value => {
        if(value.estado == true){
          if(value.subsistema.nombre == "EDUCACIÓN REGULAR"){
            if(value.subgrupo.nombre="ÁREA DE COMUNICACIÓN Y LENGUAJES" && value.grupo.nombre=="BIBLIOGRAFÍA EDUCACIÓN SECUNDARIA COMUNITARIA PRODUCTIVA"){
              this.regular.secComunicacionYLenguajes.push({'item':value.Item,'link':value.link,'archivo':value.Archivo});
            }
          }
        }
      });
    },
    makeSecCosmovisiones(biblio){
      this.regular.secCosmovisiones = [];
      biblio.forEach(value => {
        if(value.estado == true){
          if(value.subsistema.nombre == "EDUCACIÓN REGULAR"){
            if(value.subgrupo.nombre="ÁREA: COSMOVISIONES, FILOSOFÍA Y SICOLOGÍA" && value.grupo.nombre=="BIBLIOGRAFÍA EDUCACIÓN SECUNDARIA COMUNITARIA PRODUCTIVA"){
              this.regular.secCosmovisiones.push({'item':value.Item,'link':value.link,'archivo':value.Archivo});
            }
          }
        }
      });
    },
    makeSecFisica(biblio){
      this.regular.secFisica = [];
      biblio.forEach(value => {
        if(value.estado == true){
          if(value.subsistema.nombre == "EDUCACIÓN REGULAR"){
            if(value.subgrupo.nombre="ÁREA: FÍSICA" && value.grupo.nombre=="BIBLIOGRAFÍA EDUCACIÓN SECUNDARIA COMUNITARIA PRODUCTIVA"){
              this.regular.secFisica.push({'item':value.Item,'link':value.link,'archivo':value.Archivo});
            }
          }
        }
      });
    },
    makeSecQuimica(biblio){
      this.regular.secQuimica = [];
      biblio.forEach(value => {
        if(value.estado == true){
          if(value.subsistema.nombre == "EDUCACIÓN REGULAR"){
            if(value.subgrupo.nombre="ÁREA: QUÍMICA" && value.grupo.nombre=="BIBLIOGRAFÍA EDUCACIÓN SECUNDARIA COMUNITARIA PRODUCTIVA"){
              this.regular.secQuimica.push({'item':value.Item,'link':value.link,'archivo':value.Archivo});
            }
          }
        }
      });
    },
    makeSecTecnicaTecnologica(biblio){
      this.regular.secTecnicaTecnologica = [];
      biblio.forEach(value => {
        if(value.estado == true){
          if(value.subsistema.nombre == "EDUCACIÓN REGULAR"){
            if(value.subgrupo.nombre="ÁREA: TÉCNICA TECNOLÓGICA" && value.grupo.nombre=="BIBLIOGRAFÍA EDUCACIÓN SECUNDARIA COMUNITARIA PRODUCTIVA"){
              this.regular.secTecnicaTecnologica.push({'item':value.Item,'link':value.link,'archivo':value.Archivo});
            }
          }
        }
      });
    },
    makeSecValores(biblio){
      this.regular.secValores = [];
      biblio.forEach(value => {
        if(value.estado == true){
          if(value.subsistema.nombre == "EDUCACIÓN REGULAR"){
            if(value.subgrupo.nombre="ÁREA: VALORES, ESPIRITUALIDAD Y RELIGIONES" && value.grupo.nombre=="BIBLIOGRAFÍA EDUCACIÓN SECUNDARIA COMUNITARIA PRODUCTIVA"){
              this.regular.secValores.push({'item':value.Item,'link':value.link,'archivo':value.Archivo});
            }
          }
        }
      });
    },
    makeSecLenguaExtranjera(biblio){
      this.regular.secLenguaExtranjera = [];
      biblio.forEach(value => {
        if(value.estado == true){
          if(value.subsistema.nombre == "EDUCACIÓN REGULAR"){
            if(value.subgrupo.nombre="ÁREA DE LENGUA EXTRANJERA" && value.grupo.nombre=="BIBLIOGRAFÍA EDUCACIÓN SECUNDARIA COMUNITARIA PRODUCTIVA"){
              this.regular.secLenguaExtranjera.push({'item':value.Item,'link':value.link,'archivo':value.Archivo});
            }
          }
        }
      });
    },
    makeSecEducacionMusical(biblio){
      this.regular.secEducacionMusical = [];
      biblio.forEach(value => {
        if(value.estado == true){
          if(value.subsistema.nombre == "EDUCACIÓN REGULAR"){
            if(value.subgrupo.nombre="ÁREA: EDUCACIÓN MUSICAL" && value.grupo.nombre=="BIBLIOGRAFÍA EDUCACIÓN SECUNDARIA COMUNITARIA PRODUCTIVA"){
              this.regular.secEducacionMusical.push({'item':value.Item,'link':value.link,'archivo':value.Archivo});
            }
          }
        }
      });
    },
    makeSecMatematica(biblio){
      this.regular.secMatematica = [];
      biblio.forEach(value => {
        if(value.estado == true){
          if(value.subsistema.nombre == "EDUCACIÓN REGULAR"){
            if(value.subgrupo.nombre="ÁREA: MATEMÁTICA" && value.grupo.nombre=="BIBLIOGRAFÍA EDUCACIÓN SECUNDARIA COMUNITARIA PRODUCTIVA"){
              this.regular.secMatematica.push({'item':value.Item,'link':value.link,'archivo':value.Archivo});
            }
          }
        }
      });
    },
    makeSecArtesPlasticas(biblio){
      this.regular.secArtesPlasticas = [];
      biblio.forEach(value => {
        if(value.estado == true){
          if(value.subsistema.nombre == "EDUCACIÓN REGULAR"){
            if(value.subgrupo.nombre="ÁREA DE ARTES PLÁSTICAS Y VISUALES" && value.grupo.nombre=="BIBLIOGRAFÍA EDUCACIÓN SECUNDARIA COMUNITARIA PRODUCTIVA"){
              this.regular.secArtesPlasticas.push({'item':value.Item,'link':value.link,'archivo':value.Archivo});
            }
          }
        }
      });
    },
    makeSecEducacionFisica(biblio){
      this.regular.secEducacionFisica = [];
      biblio.forEach(value => {
        if(value.estado == true){
          if(value.subsistema.nombre == "EDUCACIÓN REGULAR"){
            if(value.subgrupo.nombre="ÁREA: EDUCACIÓN FÍSICA Y DEPORTES" && value.grupo.nombre=="BIBLIOGRAFÍA EDUCACIÓN SECUNDARIA COMUNITARIA PRODUCTIVA"){
              this.regular.secEducacionFisica.push({'item':value.Item,'link':value.link,'archivo':value.Archivo});
            }
          }
        }
      });
    },
    makeBibliografiaEducacionAyE(){
      let tmpArray = [];
      this.bibliografiasParsed.forEach(value => {
        if(value.subsistema == 'EDUCACIÓN ALTERNATIVA Y ESPECIAL'){
          tmpArray = value;
        }
      });
      this.bibliografiaEducacionAyE = tmpArray.grupos;
    },
    async loadBibliografias(){
      try {
        this.bibliografias = (await axios.get("/strapi/strapi-portal/bibliografias?_sort=created_at:ASC&subsistema.nombre=EDUCACI%C3%93N%20ALTERNATIVA%20Y%20ESPECIAL")).data;
        //this.bibliografias = (await axios.get('http://sisep.minedu.gob.bo:8082/bibliografias?_sort=created_at:ASC&subsistema.nombre=EDUCACI%C3%93N%20ALTERNATIVA%20Y%20ESPECIAL')).data;
        this.parseBibliografias();
        this.makeBibliografiaEducacionAyE();
        let url = '/strapi/strapi-portal/bibliografias?_sort=created_at:ASC&subsistema.nombre=EDUCACI%C3%93N%20REGULAR&';
        //let url = 'http://sisep.minedu.gob.bo:8082/bibliografias?_sort=created_at:ASC&subsistema.nombre=EDUCACI%C3%93N%20REGULAR&';
        this.makeNormativaGeneral((await axios.get(url + 'subgrupo.nombre=NORMATIVA%20GENERAL')).data);
        this.makeCalidadEducativa((await axios.get(url + 'subgrupo.nombre=CALIDAD%20EDUCATIVA')).data);
        this.makeNormativaEspecifica((await axios.get(url + 'subgrupo.nombre=NORMATIVA%20ESPEC%C3%8DFICA%20-%20SUBSISTEMA%20DE%20EDUCACI%C3%93N%20REGULAR')).data);
        this.makeEducacionInicial((await axios.get(url + 'grupo.nombre=BIBLIOGRAF%C3%8DA%20EDUCACI%C3%93N%20INICIAL%20EN%20FAMILIA%20COMUNITARIA')).data);
        this.makeEducacionPrimaria((await axios.get(url + 'grupo.nombre=BIBLIOGRAF%C3%8DA%20EDUCACI%C3%93N%20PRIMARIA%20COMUNITARIA%20VOCACIONAL')).data);
        this.makeSecNormativaGeneral((await axios.get(url + 'grupo.nombre=BIBLIOGRAF%C3%8DA%20EDUCACI%C3%93N%20SECUNDARIA%20COMUNITARIA%20PRODUCTIVA&subgrupo.nombre=NORMATIVA%20GENERAL')).data);
        this.makeSecNormativaEspecifica((await axios.get(url + 'grupo.nombre=BIBLIOGRAF%C3%8DA%20EDUCACI%C3%93N%20SECUNDARIA%20COMUNITARIA%20PRODUCTIVA&subgrupo.nombre=NORMATIVA%20ESPEC%C3%8DFICA%20-%20SUBSISTEMA%20DE%20EDUCACI%C3%93N%20REGULAR')).data);

        this.makeSecCienciasNaturales((await axios.get(url + 'grupo.nombre=BIBLIOGRAFÍA%20EDUCACIÓN%20SECUNDARIA%20COMUNITARIA%20PRODUCTIVA&subgrupo.nombre=ÁREA%20DE%20CIENCIAS%20NATURALES:%20BIOLOGÍA%20–%20GEOGRAFÍA')).data);
        this.makeSecCienciasSociales((await axios.get(url + 'grupo.nombre=BIBLIOGRAFÍA%20EDUCACIÓN%20SECUNDARIA%20COMUNITARIA%20PRODUCTIVA&subgrupo.nombre=ÁREA%20DE%20CIENCIAS%20SOCIALES')).data);
        this.makeSecComunicacionYLenguajes((await axios.get(url + 'grupo.nombre=BIBLIOGRAFÍA%20EDUCACIÓN%20SECUNDARIA%20COMUNITARIA%20PRODUCTIVA&subgrupo.nombre=ÁREA%20DE%20COMUNICACIÓN%20Y%20LENGUAJES')).data);
        this.makeSecCosmovisiones((await axios.get(url + 'grupo.nombre=BIBLIOGRAFÍA%20EDUCACIÓN%20SECUNDARIA%20COMUNITARIA%20PRODUCTIVA&subgrupo.nombre=ÁREA:%20COSMOVISIONES,%20FILOSOFÍA%20Y%20SICOLOGÍA')).data);
        this.makeSecFisica((await axios.get(url + 'grupo.nombre=BIBLIOGRAFÍA%20EDUCACIÓN%20SECUNDARIA%20COMUNITARIA%20PRODUCTIVA&subgrupo.nombre=ÁREA:%20FÍSICA')).data);
        this.makeSecQuimica((await axios.get(url + 'grupo.nombre=BIBLIOGRAFÍA%20EDUCACIÓN%20SECUNDARIA%20COMUNITARIA%20PRODUCTIVA&subgrupo.nombre=ÁREA:%20QUÍMICA')).data);
        this.makeSecTecnicaTecnologica((await axios.get(url + 'grupo.nombre=BIBLIOGRAFÍA%20EDUCACIÓN%20SECUNDARIA%20COMUNITARIA%20PRODUCTIVA&subgrupo.nombre=ÁREA:%20TÉCNICA%20TECNOLÓGICA')).data);
        this.makeSecValores((await axios.get(url + 'grupo.nombre=BIBLIOGRAF%C3%8DA%20EDUCACI%C3%93N%20SECUNDARIA%20COMUNITARIA%20PRODUCTIVA&subgrupo.nombre=%C3%81REA:%20VALORES,%20ESPIRITUALIDAD%20Y%20RELIGIONES')).data);
        this.makeSecLenguaExtranjera((await axios.get(url + 'grupo.nombre=BIBLIOGRAFÍA%20EDUCACIÓN%20SECUNDARIA%20COMUNITARIA%20PRODUCTIVA&subgrupo.nombre=ÁREA%20DE%20LENGUA%20EXTRANJERA')).data);
        this.makeSecEducacionMusical((await axios.get(url + 'grupo.nombre=BIBLIOGRAFÍA%20EDUCACIÓN%20SECUNDARIA%20COMUNITARIA%20PRODUCTIVA&subgrupo.nombre=ÁREA:%20EDUCACIÓN%20MUSICAL')).data);
        this.makeSecMatematica((await axios.get(url + 'grupo.nombre=BIBLIOGRAFÍA%20EDUCACIÓN%20SECUNDARIA%20COMUNITARIA%20PRODUCTIVA&subgrupo.nombre=ÁREA:%20MATEMÁTICA')).data);
        this.makeSecArtesPlasticas((await axios.get(url + 'grupo.nombre=BIBLIOGRAFÍA%20EDUCACIÓN%20SECUNDARIA%20COMUNITARIA%20PRODUCTIVA&subgrupo.nombre=ÁREA%20DE%20ARTES%20PLÁSTICAS%20Y%20VISUALES')).data);
        this.makeSecEducacionFisica((await axios.get(url + 'grupo.nombre=BIBLIOGRAFÍA%20EDUCACIÓN%20SECUNDARIA%20COMUNITARIA%20PRODUCTIVA&subgrupo.nombre=ÁREA:%20EDUCACIÓN%20FÍSICA%20Y%20DEPORTES')).data);
      } catch (error) {
        this.$snotify.error("No se pudo cargar las Bibliografías");
      }
    },
    onChangeTerm(){
      if(this.time){
        clearTimeout(this.time);
      }
      this.time = setTimeout(function(){
        this.$redrawVueMasonry('masonry-grid-1');
        this.$redrawVueMasonry('masonry-grid-2');
      }.bind(this),400);
    },
    updateMan(){
      setTimeout(function(){
        this.$redrawVueMasonry('masonry-grid-1')
        this.$redrawVueMasonry('masonry-grid-2')
      }.bind(this),400);
    },
    abrirPrecarga(){
      this.dialogoPrecarga = true;
      this.value = 0;
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        if(this.value == 100){
          clearInterval(this.interval);
          this.value = 95
          setTimeout(()=>{
            this.showFormPopup()
          },1200)
        }
        this.value += 5
      }, 200);
    },
    cancelarPrecarga(){
      clearInterval(this.interval)
    },
    showFormPopup(){
      this.dialogoPrecarga = false
      this.dialogoFormulario = true
    }
  },
  async created(){
    if(this.$route.query.view){
      if(this.$route.query.view == 'bibliografia'){
        await this.sleep(500);
        this.currentTab=2;
        await this.sleep(500);
        this.scrollToBTabs();
      }
      else if(this.$route.query.view == 'directrices'){
        await this.sleep(500);
        this.currentTab=3;
        await this.sleep(500);
        this.scrollToBTabs();
      }
    }
    this.loadBibliografias()
    this.loadSuperior()
    this.loadSuperiorArt()
  }
};
</script>